import classNames from "classnames/dedupe";
import React, { ElementType, FC, ReactNode } from "react";
import { TThemeVariant, useTheme } from "../../Utility/ThemeProvider";

export interface IFormCheckWrapperProps {
  /**
   * Visual representation of component
   *
   */
  variant?: TThemeVariant;
  isFilterRow?: boolean;
  isToggle?: boolean;
  tag?: ElementType;
  classes?: { root?: string };
  children?: ReactNode;
}

const FormCheckWrapper: FC<IFormCheckWrapperProps> = ({
  variant,
  tag: WrapperTag = "div",
  classes,
  children,
  isFilterRow = false,
  isToggle = false,
}) => {
  const theme: TThemeVariant = useTheme(variant);

  const rootClasses = classNames("form-check", classes?.root, {
    "form-check--toggle-radio": isToggle,
    "form-check--light": theme === "light",
    "form-check--filter": isFilterRow,
  });

  return (
    <WrapperTag data-testid="FormCheckWrapper" className={rootClasses}>
      {children}
    </WrapperTag>
  );
};

export default FormCheckWrapper;
